import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/quasar.styl'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css';
import 'vue-tel-input/dist/vue-tel-input.css'
import _ from  'lodash'
import * as Ramda from 'ramda'
import store from './store'
import firebasePlugin from '@/plugins/firebase.js'
import CommandPlugin from '@/plugins/Command'
import VeeValidate from 'vee-validate'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import NafComponents from 'NafComponents/fields-generator/index.js'
import FieldsGenerator from 'NafComponents/fields-generator/FieldsGenerator.vue'
import { Validator } from 'vee-validate'
import InitRules from 'NafComponents/fields-generator/custom-validation-rules'
import ValidateDictionary from 'NafComponents/fields-generator/custom-validation-rules/dictionary.js'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'


import {
  Quasar, 
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QSpace,
  QSpinnerBall,
  QInput,
  QDialog,
  QCard,
  QCardSection,
  QCardActions,
  ClosePopup,
  QInnerLoading,
  QRouteTab,
  QImg,
  QAvatar,
  QScrollArea,
  QTable,
  QTr,
  QTd,
  QTh,
  QSelect,
  Notify,
  QOptionGroup,
  QAjaxBar,
  QChip,
  QDate,
  QPopupProxy,
  QSeparator,
  QFab,
  QFabAction,
  QPageSticky,
  QSpinnerTail,
  QCheckbox,
  QUploader,
  QPageScroller,
  QExpansionItem,
  QTooltip,
  QMarkupTable
} from 'quasar'

Vue.use(Quasar, {
  config: {
    loading: {
      spinner: QSpinnerBall
    },
  },
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QSpace,
    QSpinnerBall,
    QInput,
    QDialog,
    QCard,
    QCardSection,
    QCardActions,
    QInnerLoading,
    QRouteTab,
    QImg,
    QAvatar,
    QScrollArea,
    QTable,
    QTr,
    QTd,
    QTh,
    QSelect,
    QOptionGroup,
    QAjaxBar,
    QChip,
    QDate,
    QPopupProxy,
    QSeparator,
    QFab,
    QFabAction,
    QPageSticky,
    QSpinnerTail,
    QCheckbox,
    QUploader,
    QPageScroller,
    QExpansionItem,
    QTooltip,
    QMarkupTable
  },
  directives: {
    ClosePopup
  },
  plugins: {
    Notify
  }
 })

Vue.config.productionTip = false
Vue.use(NafComponents)
Vue.use(firebasePlugin)
Vue.component('fields-generator', FieldsGenerator)
Vue.set(Vue.prototype, '_', _)
Vue.set(Vue.prototype, 'R', Ramda)
Vue.use(CommandPlugin)
Vue.use(VeeValidate)
Vue.use(ValidationObserver)
Vue.use(ValidationProvider)
Validator.localize(ValidateDictionary)
InitRules(Validator)
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://ebdd46a63cb54e5fa06b53ce50f7b732@sentry.io/1480149',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
}